import { useFormatConstraints, estimatePagesFromWords } from "@/hooks/use-format";

interface ProposalStatsBarProps {
  wordCount: number;
  sectionsCompleted: number;
  sectionsTotal: number;
  /** Para calibrar la estimación de páginas y compararla con el límite. */
  licitacionId?: string;
}

export function ProposalStatsBar({
  wordCount,
  sectionsCompleted,
  sectionsTotal,
  licitacionId,
}: ProposalStatsBarProps) {
  const { data: constraint } = useFormatConstraints(licitacionId);
  const estimatedPages = estimatePagesFromWords(wordCount, {
    font_size_pt: constraint?.font_size_pt,
    line_spacing: constraint?.line_spacing,
  });
  const maxPages = constraint?.max_pages ?? null;

  // Color del contador de páginas según la cercanía al límite.
  let pageClass = "text-gray-500";
  let pageLabel = `~${estimatedPages} ${
    estimatedPages === 1 ? "página" : "páginas"
  }`;
  if (maxPages) {
    pageLabel = `~${estimatedPages} / ${maxPages} páginas`;
    if (estimatedPages > maxPages) pageClass = "text-red-600 font-medium";
    else if (estimatedPages >= maxPages * 0.9)
      pageClass = "text-amber-600 font-medium";
    else pageClass = "text-emerald-600";
  }

  return (
    <div className="border-t border-gray-200 px-4 py-2 text-sm text-gray-500 flex items-center gap-1">
      <span>{wordCount.toLocaleString("es-ES")} palabras</span>
      <span>·</span>
      <span
        className={pageClass}
        title={
          maxPages
            ? "Estimación aproximada por extensión de texto. El número definitivo es el del PDF (Análisis → Formato y páginas)."
            : "Estimación aproximada por extensión de texto."
        }
      >
        {pageLabel}
        {maxPages && estimatedPages > maxPages ? " · te pasas" : ""}
      </span>
      <span>·</span>
      <span>
        {sectionsCompleted}/{sectionsTotal} secciones completadas
      </span>
    </div>
  );
}
